import { OrgTypeContract } from './org-type.contract';
import { OrganizationContract } from './organization.contract';

export interface KindergartenContract {
  id: number;
  uuid: string;
  code: string;
  name: string;
  law_id: string;
  note: string;
  product_codenames?: string[];
  org_type?: OrgTypeContract[];
  e_enrollment_state?: boolean;
  is_demo?: boolean;
  is_primary?: boolean;
  address_street?: string;
  address_city?: string;
  address_district?: string | null;
  address_postcode?: string;
  address_country?: string;
  official_name?: string;
  organization?: OrganizationContract;
}
